import type { AppProps } from 'next/app'
import Head from 'next/head'

import '../../styles/globals.css'
import dynamic from 'next/dynamic'
import { ShopifyConsentTrackingScript } from '../storefront/components/shared/ShopifyConsentTrackingScript'
import { LandingPageProps } from '../types'

const DatadogInit = dynamic(
    () => import('../storefront/components/shared/DatadogInit'),
)

function MyApp({ Component, pageProps }: AppProps<LandingPageProps>) {
    return (
        <>
            {/* meta viewport necessary for in app browser rendering */}
            <Head>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, viewport-fit=cover"
                />
            </Head>
            <DatadogInit
                landingPageHash={pageProps.landingPage?.landingPageHash}
            />
            <ShopifyConsentTrackingScript />
            <Component {...pageProps} />
            <div id="modal-root"></div>
        </>
    )
}

export default MyApp
